import { Api } from "../Api";
import { DataFrame, Method, Status } from "../DataFrame";
import { IDIService } from "../IDIService";
import { ExalusConnectionService } from "./ExalusConnectionService";
import { IExalusConnectionService } from "./IExalusConnectionService";

interface IHomeKitService extends IDIService {
    GetPairingStatusAsync(): Promise<HomeKitPairingStatusResponse | Status>;
    IsPairedAsync(): Promise<boolean | Status>;
    ResetPairingAsync(): Promise<Status>;
}

export class HomeKitService implements IHomeKitService {
    static ServiceName: string = "HomeKitService";
    private _connection: IExalusConnectionService;

    constructor() {
        this._connection = Api.Get<IExalusConnectionService>(
            ExalusConnectionService.ServiceName
        );
    }

    GetServiceName(): string {
        return HomeKitService.ServiceName;
    }

    private isHomeKitPairingStatusResponse(
        value: unknown
    ): value is HomeKitPairingStatusResponse {
        return (
            typeof value === "object" &&
            value !== null &&
            "Paired" in value &&
            typeof (value as { Paired?: unknown }).Paired === "boolean"
        );
    }

    async GetPairingStatusAsync(): Promise<HomeKitPairingStatusResponse | Status> {
        const req = new GetPairingStatusFrame();
        const result = await this._connection.SendAndWaitForResponseAsync<unknown>(
            req,
            5000,
            false
        );

        if (result.Status !== Status.OK) {
            return result.Status as Status;
        }

        const response = new HomeKitPairingStatusResponse();

        if (this.isHomeKitPairingStatusResponse(result.Data)) {
            response.Paired = result.Data.Paired;
        }

        return response;
    }

    async IsPairedAsync(): Promise<boolean | Status> {
        const res = await this.GetPairingStatusAsync();

        if (this.isHomeKitPairingStatusResponse(res)) {
            return res.Paired;
        }

        return res;
    }

    async ResetPairingAsync(): Promise<Status> {
        const req = new ResetPairingFrame();
        const result = await this._connection.SendAndWaitForResponseAsync<any>(
            req,
            5000,
            false
        );

        return result.Status as Status;
    }
}

export class HomeKitPairingStatusResponse {
    public Paired: boolean = false;
}

class GetPairingStatusFrame extends DataFrame<any> {
    constructor() {
        super();
        this.Resource = "/homekit/pairing/status";
        this.Method = Method.Get;
    }
}

class ResetPairingFrame extends DataFrame<any> {
    constructor() {
        super();
        this.Resource = "/homekit/pairing/reset";
        this.Method = Method.Post;
    }
}